<template>
  <p class="PoweredBy">
    {{ label || t('ui.global.poweredBy') }}
    <img :src="CaraveloLogo" alt="Caravelo" class="PoweredBy-logo">
  </p>
</template>

<script setup lang="ts">
import CaraveloLogo from '@cvo/ui/imgs/caravelo-logo.png';
import { useI18n } from '@cvo/i18n/composables/useI18n';

defineProps<{
  label?: string
}>();

const { t } = useI18n();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;

@layer cvo-ui {
  .PoweredBy {
    display: flex;
    align-items: center;
    margin-block-start: vars.$dimensions-d-3;
    color: vars.$color-neutral-gray-700;

    .PoweredBy-logo {
      height: 0.9em;
      display: inline-block;
      margin-inline-start: vars.$dimensions-d-1;
    }
  }
}
</style>
